import React from "react";
import {Link} from "@quintype/components"
import {Button} from "../basic/button"

import './not-found.module.css'

function NotFoundPage() {
  return <div styleName="not-found-page">
    <h1 styleName="status-code" data-testid = "404">404</h1>
    <p styleName="info" data-testid = "page-not-found">Oops.. Page not found !</p>
    <p styleName="description">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
    <Link href="/">
      <Button classNamesString="qt-button--transparent qt-theme__color qt-theme__color--border" data-testid = "redirect-homepage-button">Take me to home</Button>
    </Link>
  </div>
}

export { NotFoundPage };
